(function () {
  'use strict';

  if (window.__rd3JudgeMeUIInitialized) return;
  window.__rd3JudgeMeUIInitialized = true;

  var formSelector = '.jdgm-write-review-modal';
  var closeSelector = '.jdgm-write-review-modal__close-btn';
  var pageSelector = '.jdgm-write-review-modal__page';
  var thankYouSelector = '.jdgm-write-review-modal__form--thank-you';
  var compactSelector = '.jdgm-write-review-modal__compact-body.is-active';
  var forms = new Map();

  function syncClose(form) {
    if (!form.isConnected) return;
    form.querySelectorAll(closeSelector).forEach(function (button) {
      var tabIndex = button.disabled ? '-1' : '0';
      if (button.getAttribute('aria-hidden') !== 'false') {
        button.setAttribute('aria-hidden', 'false');
      }
      if (button.getAttribute('tabindex') !== tabIndex) {
        button.setAttribute('tabindex', tabIndex);
      }
    });
  }

  function scrollWithin(pane, target) {
    if (pane.clientHeight < 1 || pane.scrollHeight <= pane.clientHeight) return;
    var paneRect = pane.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var top = paneRect.top + pane.clientTop + 8;
    var bottom = paneRect.top + pane.clientTop + pane.clientHeight - 8;
    var delta = 0;

    if (targetRect.top < top || targetRect.height > bottom - top) {
      delta = targetRect.top - top;
    } else if (targetRect.bottom > bottom) {
      delta = targetRect.bottom - bottom;
    }

    if (!delta) return;
    var next = Math.max(0, Math.min(pane.scrollHeight - pane.clientHeight, pane.scrollTop + delta));
    if (Math.abs(pane.scrollTop - next) > .5) pane.scrollTop = next;
  }

  function ensureFocusVisible(form) {
    var target = document.activeElement;
    if (!(target instanceof Element) || !form.contains(target)) return;
    var page = target.closest(pageSelector);
    var compact = target.closest(compactSelector);
    if (!page || (!page.classList.contains('current-page') && !compact)) return;

    var thankYou = target.closest(thankYouSelector);
    if (thankYou && page.contains(thankYou)) scrollWithin(thankYou, target);
    scrollWithin(page, target);
    if (compact && form.contains(compact)) scrollWithin(compact, target);
  }

  function mount(form) {
    if (forms.has(form)) return;
    var state = { frame: 0 };

    function onFocusIn() {
      if (state.frame) cancelAnimationFrame(state.frame);
      state.frame = requestAnimationFrame(function () {
        state.frame = 0;
        if (form.isConnected) ensureFocusVisible(form);
      });
    }

    var observer = new MutationObserver(function () { syncClose(form); });
    observer.observe(form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'tabindex', 'disabled']
    });
    form.addEventListener('focusin', onFocusIn);
    state.cleanup = function () {
      observer.disconnect();
      form.removeEventListener('focusin', onFocusIn);
      if (state.frame) cancelAnimationFrame(state.frame);
    };
    forms.set(form, state);
    syncClose(form);
  }

  function inspectAdded(node) {
    if (!(node instanceof Element)) return;
    if (node.matches(formSelector)) mount(node);
    node.querySelectorAll(formSelector).forEach(mount);
  }

  document.querySelectorAll(formSelector).forEach(mount);

  var discovery = new MutationObserver(function (records) {
    var hadRemoval = false;
    records.forEach(function (record) {
      if (record.removedNodes.length) hadRemoval = true;
      record.addedNodes.forEach(inspectAdded);
    });
    if (hadRemoval) {
      forms.forEach(function (state, form) {
        if (form.isConnected) return;
        state.cleanup();
        forms.delete(form);
      });
    }
  });
  discovery.observe(document.body || document.documentElement, { childList: true, subtree: true });

  /* Escape closes the review photo popup through its own X button, the same path a click on the X takes. */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var popups = document.querySelectorAll('.jdgm-modal');
    var popup = popups[popups.length - 1];
    if (!popup || !popup.querySelector('.jm-slide')) return;
    var close = popup.querySelector('.jm-indicator__close');
    if (close) close.click();
  });
}());
